import store from "@/store"

export default {
    get experienceType() {
        return this.session?.experienceType
    },

    get providerKey() {
        return store.state.session.data?.dynamicProviderKey?.toString()
    },

    get dynamicProviderKey() {
        return store.state.session.data?.dynamicProviderKey
    },

    set dynamicProviderKey(dynamicProviderKey) {
        store.commit("session/updateDynamicProviderKey", dynamicProviderKey)
    },

    get session() {
        return store.state.session.data
    },

    set session(session) {
        store.commit("session/update", session)
    },

    get previousSession() {
        return store.state.session.previous
    },

    set previousSession(session) {
        store.commit("session/updatePrevious", session)
    },

    getProperty(name) {
        return this.session.properties[name]
    },

    getCascadeProperty(name) {
        return this.session?.cascadeProperties[name] || null
    },

    getExtensionsProperties(featureId) {
        return this.session?.extensions?.find(ext => ext.featureId === featureId)?.properties || null
    },
}
